module.exports = __webpack_public_path__ + "assets/img/ErrorPage@2x.db587e70.png";